// --- Accessibility for navigation dropdowns and variant pickers ---

// Utility: Track Tab key usage for focus style logic
const trackTabUsage = () => {
  let tabPressed = false;
  document.addEventListener('keydown', e => { if (e.key === 'Tab') tabPressed = true; });
  document.addEventListener('mousedown', () => { tabPressed = false; });
  return () => tabPressed;
};

// Utility: Close all dropdowns
const closeAllDropdowns = dropdowns =>
  dropdowns.forEach(dropdown => dropdown.removeAttribute('data-open'));

// Accessibility for navigation dropdowns
const accessibilityNavigation = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.site-nav--has-dropdown button');
    const dropdowns = document.querySelectorAll('.mega-menu__dropdown');
    const links = document.querySelectorAll('.site-nav--no-dropdown a');
    const isTab = trackTabUsage();

    // Focus on dropdown button: open relevant dropdown
    buttons.forEach((button, i) => {
      // Open on Enter key
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          closeAllDropdowns(dropdowns);
          dropdowns[i].setAttribute('data-open', '');
        }
      });
    });

    // Focus on simple nav link: close all dropdowns
    links.forEach(link => {
      link.addEventListener('focusin', () => {
        if (isTab()) closeAllDropdowns(dropdowns);
      });
    });

    // Click outside dropdown: close all
    document.addEventListener('mousedown', e => {
      if (!e.target.closest('.mega-menu__dropdown') && !e.target.closest('.site-nav--has-dropdown button')) {
        closeAllDropdowns(dropdowns);
      }
    });
  });
};

// Accessibility for product variant pickers
const accessibilityVariantPicker = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const isTab = trackTabUsage();

    // Add focus style on Variant Picker
    document.addEventListener('focusin', e => {
      const select = e.target.closest('.legona-product-select-container.select');
      const quantity = e.target.closest('.legona-quantatyinvariant-container .quantity');
      if (e.target.classList.contains('quantity__button') || e.target.classList.contains('quantity__input')) {
        e.target.setAttribute('data-focus', '');
      }
      if (select && isTab()) select.setAttribute('data-focus', '');
      if (quantity && isTab()) quantity.setAttribute('data-focus', '');
    });

    // Remove focus style
    document.addEventListener('focusout', e => {
      const select = e.target.closest('.legona-product-select-container.select');
      const quantity = e.target.closest('.legona-quantatyinvariant-container .quantity');
      if (e.target.classList.contains('quantity__button') || e.target.classList.contains('quantity__input')) {
        e.target.removeAttribute('data-focus');
      }
      if (select) select.removeAttribute('data-focus');
      if (quantity) quantity.removeAttribute('data-focus');
    });
  });
};

// Init
accessibilityNavigation();
accessibilityVariantPicker();